// Default page title, can be used e.g. in routing files.

export const DEFAULT_TITLE = 'Just Eat for Business | Corporate Catering & Office Food Delivery Service';
